import React from 'react';
import styled from 'styled-components';
import { Box, Card, Flex, Text, NextLinkFromReactRouter, CopyButton } from '@pancakeswap/uikit'
import LogoLoader from 'views/Info/components/CurrencyLogo/LogoLoader';
import { CopyButtonContainer } from 'views/LaunchPad/styles';

const CardWrapper = styled.div`
  display: inline-block;
  min-width: 190px;
  margin-left: 16px;
  :hover {
    cursor: pointer;
    opacity: 0.6;
  }
`

const TopMoverCard = styled(Box)`
  padding: 16px;
`
const StyledLogo = styled(LogoLoader) <{ size: string }>`
  width: ${({ size }) => size};
  height: ${({ size }) => size};
  border-radius: ${({ size }) => size};
  box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.075);
  background-color: ${({ theme }) => theme.colors.background};
  color: ${({ theme }) => theme.colors.text};
`

// const TokenCard = ({ token }) => (
// <CardWrapper>
//       <TopMoverCard>
//         <Flex>
//           <Box width="32px" height="32px">    
//           <StyledLogo size='24px' src={token.logoUrl} alt="token logo" />
//           </Box>
//           <Box ml="16px" width="100%">
//             <Text>{token.name}</Text>
//           </Box>
//         </Flex>
//       </TopMoverCard>
//     </CardWrapper>
// );

const TokenCard = ({ token }) => (
  <CardWrapper>
    <TopMoverCard>
      <Flex alignItems="center" justifyContent="center" justifyItems="center">
        <StyledLogo size='24px' src={token.logoUrl} alt="token logo" />
        <Text marginLeft="10px">{token.name}</Text>
        <CopyButtonContainer>
          <CopyButton
            marginLeft="5px"
            width="16px"
            buttonColor="textSubtle"
            text={token.tokenAddress}
            tooltipMessage={`${token.symbol} address copied`}
          /></CopyButtonContainer>
      </Flex>
    </TopMoverCard>
  </CardWrapper>
);

export default TokenCard;
